import WarnFormItem from './WarnFormItem'

export { default as SearchSinger } from './SearchSinger'
export { default as VerifyUploader } from './VerifyUploader'
export { default as FragmentUploader } from './FragmentUploader/index.vue'

export default {
  install(Vue) {
    Vue.component(WarnFormItem.name, WarnFormItem)
  }
}
